var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"m6 18 6-6m0 0 6-6m-6 6L6 6m6 6 6 6","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }